import type { ReactNode } from 'react';
import { useRfSimulatorEnabled } from '@/shared/config/useFeatures';

/**
 * slice-4482 (John 29 Oct): route wrapper for the RF Simulator — every demo box, plus a non-demo
 * box that turns on {@code ph10.rf-simulator.enabled} (ph10-test). Off renders the router's
 * "Not found.", the same as {@link RequireDemoSystem}.
 */
export function RequireRfSimulator({ children }: { children: ReactNode }) {
  const enabled = useRfSimulatorEnabled();
  if (!enabled) return <div className="text-slate-500">Not found.</div>;
  return <>{children}</>;
}
